/**
 * Graphql mutation to submit an Expense Inventory case.
 * The backend resolver is synchronous (runs the reservation/Salesforce write inline in a single
 * transaction and returns the terminal result directly) — it does not follow the async
 * queued/polled submission contract used by submitInventoryRequest/submitUsageSheet.
 * @module src/graphql/mutations/submitExpenseInventory
 */
import gql from 'graphql-tag';

const SUBMIT_EXPENSE_INVENTORY = gql`
  mutation submitExpenseInventory(
    $caseId: String
    $caseExternalId: String
    $expectedCaseVersion: String
    $header: ExpenseInventoryHeaderInput
  ) {
    submitExpenseInventory(
      caseId: $caseId
      caseExternalId: $caseExternalId
      expectedCaseVersion: $expectedCaseVersion
      header: $header
    ) {
      message
      externalId
      sfid
    }
  }
`;

export default SUBMIT_EXPENSE_INVENTORY;
